export default JSON.parse(`{
  "09072f81-7c8e-4bce-80ad-6d9a821a2897": {
    "name": "white-space nowrap",
    "units": {
      "box": {
        "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
        "input": {},
        "metadata": {
          "component": {
            "width": 120,
            "height": 210
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{'white-space':'nowrap',overflow:'auto'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "box": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "column flexbox",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "box",
          "default"
        ]
      ],
      "defaultWidth": 180,
      "defaultHeight": 270,
      "subComponents": {
        "box": {
          "children": []
        }
      },
      "children": [
        "box"
      ]
    },
    "id": "09072f81-7c8e-4bce-80ad-6d9a821a2897",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "9988a56e-6bee-46c8-864c-e351d84bc7e2": {
    "name": "text box",
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value"
          }
        }
      },
      "attr": {
        "plug": {
          "0": {
            "unitId": "box",
            "pinId": "attr"
          }
        }
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "box",
            "pinId": "style"
          }
        }
      }
    },
    "outputs": {
      "div": {
        "plug": {
          "0": {
            "unitId": "box",
            "pinId": "_self"
          }
        },
        "defaultIgnored": true,
        "ref": true,
        "component": true
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value"
          }
        }
      }
    },
    "units": {
      "box": {
        "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "component": {
            "width": 232.120361328125,
            "height": 187.77685546875
          },
          "position": {
            "x": -21,
            "y": -94
          }
        }
      },
      "text": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
        "input": {
          "value": {}
        },
        "output": {
          "value": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 20,
            "y": 93
          }
        }
      }
    },
    "merges": {},
    "component": {
      "subComponents": {
        "box": {
          "children": [
            "text"
          ]
        },
        "text": {
          "children": []
        }
      },
      "children": [
        "box"
      ],
      "defaultWidth": 240,
      "defaultHeight": 180
    },
    "metadata": {
      "description": "text inside a box",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "cef90fb7-bfcb-4f9d-8828-df6e68278601": {
    "name": "scroll snap y box",
    "units": {
      "white-spacenowrap": {
        "id": "09072f81-7c8e-4bce-80ad-6d9a821a2897",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 251,
            "y": -124
          }
        }
      },
      "inheritdisplayinline-block": {
        "id": "e16f9ac0-29c3-4ae7-a2e7-2aa6b98bcc1b",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 86,
            "y": 194
          }
        }
      },
      "inheritscroll-snapy": {
        "id": "5867c5b6-24f2-4bd7-90b3-4e44615bc42c",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -93,
            "y": -179
          }
        }
      },
      "inheritscroll-snap-alignstart": {
        "id": "b62c0058-9183-435f-baae-c51a3ee1855b",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -247,
            "y": 107
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "white-spacenowrap",
            "pinId": "style",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": false
      }
    },
    "outputs": {},
    "component": {
      "slots": [
        [
          "inheritscroll-snap-alignstart",
          "default"
        ]
      ],
      "children": [
        "inheritscroll-snapy"
      ],
      "subComponents": {
        "white-spacenowrap": {
          "children": [
            "inheritdisplayinline-block"
          ]
        },
        "inheritdisplayinline-block": {
          "children": [
            "inheritscroll-snap-alignstart"
          ]
        },
        "inheritscroll-snapy": {
          "children": [
            "white-spacenowrap"
          ]
        },
        "inheritscroll-snap-alignstart": {
          "children": []
        }
      },
      "metadata": {
        "icon": "square",
        "description": "container with y scroll snap",
        "complexity": 109
      },
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "id": "cef90fb7-bfcb-4f9d-8828-df6e68278601",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "metadata": {
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "system": true
  },
  "5867c5b6-24f2-4bd7-90b3-4e44615bc42c": {
    "name": "inherit scroll-snap y",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "inherit": {
        "id": "b5286262-9f92-40d3-8545-88fb3079a0f9",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 103,
            "y": -1
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{\\"scroll-snap-type\\":'y mandatory',\\"scroll-snap-stop\\":\\"always\\"}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -104,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "inherit": {
          "input": {
            "style": true
          }
        }
      }
    },
    "render": true,
    "component": {
      "slots": [
        [
          "inherit",
          "default"
        ]
      ],
      "subComponents": {
        "inherit": {
          "children": []
        }
      },
      "children": [
        "inherit"
      ],
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "metadata": {
      "icon": "square",
      "description": "style children with scroll-snap y",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "5867c5b6-24f2-4bd7-90b3-4e44615bc42c",
    "system": true
  },
  "b62c0058-9183-435f-baae-c51a3ee1855b": {
    "name": "inherit scroll-snap-align start",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "inherit": {
        "id": "b5286262-9f92-40d3-8545-88fb3079a0f9",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 103,
            "y": -1
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{\\"scroll-snap-align\\":'start'}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -104,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "inherit": {
          "input": {
            "style": true
          }
        }
      }
    },
    "render": true,
    "component": {
      "slots": [
        [
          "inherit",
          "default"
        ]
      ],
      "subComponents": {
        "inherit": {
          "children": []
        }
      },
      "children": [
        "inherit"
      ],
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "metadata": {
      "icon": "square",
      "description": "style children with scroll-snap-align start",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "b62c0058-9183-435f-baae-c51a3ee1855b",
    "system": true
  },
  "e16f9ac0-29c3-4ae7-a2e7-2aa6b98bcc1b": {
    "name": "inherit display inline-block",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "inherit": {
        "id": "b5286262-9f92-40d3-8545-88fb3079a0f9",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 103,
            "y": -1
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{\\"display\\":'inline-block',\\"vertical-align\\":\\"bottom\\"}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -104,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "inherit": {
          "input": {
            "style": true
          }
        }
      }
    },
    "render": true,
    "component": {
      "slots": [
        [
          "inherit",
          "default"
        ]
      ],
      "subComponents": {
        "inherit": {
          "children": []
        }
      },
      "children": [
        "inherit"
      ],
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "metadata": {
      "icon": "square",
      "description": "style children with display inline block",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "e16f9ac0-29c3-4ae7-a2e7-2aa6b98bcc1b",
    "system": true
  },
  "ec8afd36-0718-42f7-9b0d-4b1adbf62766": {
    "name": "horizontal scroll box",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "defaultstyle": {
        "id": "b5286262-9f92-40d3-8545-88fb3079a0f9",
        "input": {
          "style": {
            "constant": true,
            "data": "{display:\\"inline-block\\",verticalAlign:\\"bottom\\"}"
          }
        },
        "metadata": {
          "position": {
            "x": 50,
            "y": -114
          }
        }
      },
      "box": {
        "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -51,
            "y": 113
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "default": {
            "constant": true,
            "data": "{whiteSpace:\\"nowrap\\"}"
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "box": {
          "input": {
            "style": true
          }
        }
      }
    },
    "component": {
      "slots": [
        [
          "defaultstyle",
          "default"
        ]
      ],
      "subComponents": {
        "defaultstyle": {
          "children": []
        },
        "box": {
          "children": [
            "defaultstyle"
          ]
        }
      },
      "children": [
        "box"
      ],
      "defaultWidth": 300,
      "defaultHeight": 180
    },
    "metadata": {
      "icon": "square",
      "description": "horizontal scroll container",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "ec8afd36-0718-42f7-9b0d-4b1adbf62766",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "9eba84b6-d2ca-47e6-9195-8208dbb880bc": {
    "name": "box",
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {
          "attr": {
            "ignored": false
          }
        },
        "metadata": {
          "component": {
            "width": 120,
            "height": 120
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{width:'100%',height:'100%',overflow:'auto'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      },
      "attr": {
        "plug": {
          "0": {
            "unitId": "div",
            "pinId": "attr"
          }
        },
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "100% div",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "div",
          "default"
        ]
      ],
      "defaultWidth": 120,
      "defaultHeight": 120,
      "subComponents": {
        "div": {
          "children": []
        }
      },
      "children": [
        "div"
      ]
    },
    "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "97c94516-add1-11ea-ba72-8f55299b735c": {
    "name": "on click",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'click'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` click event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "97c94516-add1-11ea-ba72-8f55299b735c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "87f99b85-1c24-4e5b-a903-dd27230f4092": {
    "name": "text",
    "inputs": {
      "value": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "\\"Text\\"",
            "\\"Hello world!\\""
          ]
        }
      }
    },
    "outputs": {
      "value": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "type",
      "description": "text",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 90
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "059579bb-184f-435b-ace0-64ec95c9f125": {
    "name": "image",
    "inputs": {
      "src": {
        "type": "string",
        "metadata": {
          "description": "url pointing to a image data"
        },
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "image",
      "description": "HTML image element",
      "tags": [
        "platform",
        "component",
        "media"
      ]
    },
    "id": "059579bb-184f-435b-ace0-64ec95c9f125",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 240
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`&\`IM\`",
    "render": true,
    "system": true
  },
  "b5286262-9f92-40d3-8545-88fb3079a0f9": {
    "name": "inherit",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "apply default style to all children",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "b5286262-9f92-40d3-8545-88fb3079a0f9",
    "base": true,
    "component": {
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "66698a97-15c5-4602-9925-11a1aeb03710": {
    "name": "div",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}",
            "{background:'red'}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML div element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "66698a97-15c5-4602-9925-11a1aeb03710",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "de9665db-a188-4252-99f0-ea50fc343058": {
    "name": "scroll into view",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      }
    },
    "outputs": {
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "send",
      "description": "scroll parent until \`component\` is visible",
      "tags": [
        "platform",
        "api",
        "scroll"
      ]
    },
    "base": true,
    "id": "de9665db-a188-4252-99f0-ea50fc343058",
    "type": "\`U\`",
    "system": true
  },
  "367241d8-ad12-11ea-beed-9777f31699a8": {
    "name": "listen",
    "inputs": {
      "emitter": {
        "type": "\`EE\`",
        "ref": true
      },
      "event": {
        "type": "string"
      },
      "remove": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "data": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "listen to \`emitter\` \`event\`",
      "tags": [
        "platform",
        "api",
        "event"
      ]
    },
    "id": "367241d8-ad12-11ea-beed-9777f31699a8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "60bdba6d-c670-430f-be72-6f39cf4e8453": {
    "name": "merge",
    "inputs": {
      "a": {
        "type": "object"
      },
      "b": {
        "type": "object"
      }
    },
    "outputs": {
      "ab": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "merge two objects \`a\` and \`b\` into \`ab\`",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ba38b0af-80c0-49e4-9e39-864396964ccc": {
    "name": "wait",
    "inputs": {
      "a": {
        "type": "<A>"
      },
      "b": {
        "type": "any"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>"
      }
    },
    "metadata": {
      "icon": "git-merge",
      "description": "wait for \`b\` before output \`a\`",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "329920ae-7e91-11ea-988e-1b12488c8b89": {
    "name": "default",
    "inputs": {
      "a": {
        "type": "<A>"
      },
      "d": {
        "type": "<A>"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>"
      }
    },
    "metadata": {
      "icon": "grip-lines-vertical",
      "description": "output \`a\` if present, \`default\` if not, otherwise",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "304e98ac-bda1-11ea-b416-9746f024148c": {
    "name": "merge default",
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "b"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -125,
              "y": -7
            }
          }
        }
      },
      "default": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 0,
              "y": 37
            }
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "default",
            "pinId": "a"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 124,
              "y": -7
            }
          }
        }
      }
    },
    "units": {
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {},
          "d": {}
        },
        "output": {
          "a": {
            "metadata": {
              "position": {
                "x": 96,
                "y": -5
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 47,
            "y": -5
          }
        }
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
        "input": {
          "a": {},
          "b": {
            "metadata": {
              "position": {
                "x": -97,
                "y": -5
              }
            }
          }
        },
        "output": {
          "ab": {}
        },
        "metadata": {
          "position": {
            "x": -48,
            "y": -5
          }
        }
      }
    },
    "merges": {
      "0": {
        "default": {
          "input": {
            "d": true
          }
        },
        "merge": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "merge": {
          "output": {
            "ab": true
          }
        },
        "default": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "merge \`a\` and \`default\` if \`a\` is present, \`default\` otherwise",
      "tags": [
        "core",
        "object"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 0,
            "y": 8
          },
          "1": {
            "x": -1,
            "y": -18
          }
        }
      }
    },
    "id": "304e98ac-bda1-11ea-b416-9746f024148c",
    "type": "\`U\`&\`G\`",
    "system": true
  }
}`)
